module.exports = __webpack_public_path__ + "public/media/URBANLEADS.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/lOGO PNG/URBANLEADS.png
// module id = ./images/partners/lOGO PNG/URBANLEADS.png
// module chunks = 0